import {
  NOTIFICATIONS_DEFAULT_LIMIT,
  NOTIFICATIONS_QUERY_KEY,
} from "@frontend-shared/constants";
import type { IListNotificationsResponse } from "@frontend-shared/types";
import type { InfiniteData } from "@tanstack/react-query";
import { useInfiniteQuery } from "@tanstack/react-query";

import { notificationsApi } from "@/api/services";

import type {
  IFetchNotificationsParams,
  IUseNotificationsProps,
} from "./types";

export const notificationsQueryKey = (onlyUnread: boolean) => [
  NOTIFICATIONS_QUERY_KEY,
  { onlyUnread },
];

const fetchNotifications =
  (onlyUnread: boolean) =>
  async ({ pageParam }: IFetchNotificationsParams) => {
    const limit = NOTIFICATIONS_DEFAULT_LIMIT;
    const offset = pageParam * limit;
    return notificationsApi.list({ limit, offset, onlyUnread });
  };

export const useNotifications = ({
  onlyUnread,
  enabled,
}: IUseNotificationsProps) => {
  return useInfiniteQuery<
    IListNotificationsResponse,
    Error,
    InfiniteData<IListNotificationsResponse>,
    ReturnType<typeof notificationsQueryKey>,
    number
  >({
    queryKey: notificationsQueryKey(onlyUnread),
    queryFn: fetchNotifications(onlyUnread),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) =>
      lastPage.hasMore ? allPages.length : undefined,
    enabled,
  });
};
